import { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import Player from "@vimeo/player";
import { IModalOption } from "../../shared/interfaces/modal-option.interface";
import styles from "./VideoModalB2cStudent.module.scss";
import padLockImage from "../../../assets/images/onboarding-padlock.png";
import dotsImage from "../../../assets/images/onboarding-dots.png";

const VideoModalB2cStudent = ({ showModal, onClose, url }: IModalOption) => {
    const [videoEnded, setVideoEnded] = useState(false);
    const playerRef = useRef<any>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleNextBtn = () => {
        if (videoEnded) {
            localStorage.removeItem("preview-video");
            onClose(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            setVideoEnded(false);
            timeoutRef.current = setTimeout(() => {
                if (playerRef.current) {
                    playerRef.current.unload();
                }
                const player = new Player("OnboardingVideo", {
                    url: (url ??
                        "https://vimeo.com/1086194917") as `https://vimeo.com/${string}`,
                    responsive: true,
                    autoplay: true,
                });
                playerRef.current = player;

                player.on("ended", () => {
                    setVideoEnded(true);
                });
            }, 500);
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            if (playerRef.current) {
                playerRef.current.unload();
            }
        };
    }, [showModal, url]);

    return (
        <Modal
            isOpen={showModal}
            style={{
                content: {
                    top: "33%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -30%)",
                    width: "calc(100vw - 50px)",
                    padding: "20px",
                    maxWidth: "800px",
                    boxShadow:
                        "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
                },
            }}
        >
            <div className={`text-aha-gray ${styles.onboardingTop}`}>
                <div className={styles.onboardingHeaderContainer}>
                    <div className={styles.onboardingHeader}>
                        <img
                            src={padLockImage}
                            alt="Padlock"
                            className={styles.onboardingPadlock}
                        />
                        <h2 className="font-century-gothic-bold">
                            Before You Dive In...
                        </h2>
                    </div>
                    <img
                        src={dotsImage}
                        alt="Dots"
                        className={styles.onboardingDots}
                    />
                </div>
                <p>
                    Take a minute to watch this short video—it’ll walk you
                    through how to get started and make practice simple and
                    effective. It’s the best way to set your child (and you!) up
                    for success.
                </p>
            </div>
            <div className={styles.videoWrapper}>
                <div id="OnboardingVideo"></div>
            </div>
            <div className="text-right">
                <button
                    className={`font-century-gothic-bold ${styles.nextButton}`}
                    title="Please watch the entire video before clicking 'Next'"
                    onClick={handleNextBtn}
                    disabled={!videoEnded}
                >
                    Next
                </button>
            </div>
        </Modal>
    );
};

export default VideoModalB2cStudent;
